import { Component } from '@angular/core';

@Component({
    selector: 'app-purchases',
    templateUrl: './purchases.component.html',
    styleUrls: ['./purchases.component.css'],
    standalone: false
})
export class PurchasesComponent {

}
